module.exports = __webpack_public_path__ + "static/img/strategy-bg-top.db390fc8.png";